import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/#latest-releases", label: "Music" },
  { to: "/videos", label: "Videos" },
  { to: "/about", label: "About" },
  { to: "/news", label: "News" },
  { to: "/press", label: "Press / EPK" },
];

// Slim, fixed public navigation. Hidden on /admin.
export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/admin")) return null;

  return (
    <header data-testid="site-nav" className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${scrolled || open ? "border-b border-white/10 bg-ink/85 backdrop-blur-md" : "bg-transparent"}`}>
      <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-5 sm:px-10">
        <Link to="/" data-testid="nav-home" className="font-display text-lg font-bold uppercase tracking-tight text-white">DJ <span className="text-gold">Código</span></Link>
        <nav className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().split(" ")[0]}`} className={`text-xs font-semibold uppercase tracking-widest transition-colors hover:text-gold ${pathname === l.to ? "text-gold" : "text-white/70"}`}>{l.label}</Link>
          ))}
          <Link to="/#join" data-testid="nav-join" className="rounded-full border border-gold/50 bg-gold/10 px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-gold transition-colors hover:bg-gold hover:text-black">Join the List</Link>
        </nav>
        <button data-testid="nav-toggle" aria-label="Menu" onClick={() => setOpen((o) => !o)} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white md:hidden">
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile" className="border-t border-white/10 px-5 pb-6 pt-3 md:hidden">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="block py-3 font-display text-xl font-semibold uppercase tracking-tight text-white hover:text-gold">{l.label}</Link>
          ))}
          <Link to="/#join" className="mt-3 inline-block rounded-full bg-gold px-5 py-3 text-xs font-bold uppercase tracking-widest text-black">Join the Código List</Link>
        </nav>
      )}
    </header>
  );
}
